import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import Logo from "../assets/images/ModalLogo.png";
const GenericModal = ({
  open,
  onClose,
  title,
  children,
  footer,
  maxWidth = "756px",
  fullWidth = false,
  logoDetail,
  logo = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: maxWidth,
          width: "100%",
          borderRadius: "12px",
        },
      }}
    >
      {title && (
        <>
          <DialogTitle
            sx={{
              "&.MuiDialogTitle-root": {
                fontSize: 24,
                fontWeight: 500,
                color: "#242424",
                padding: "16px",
                "@media (max-width: 768px)": {
                  fontSize: 20,
                  padding: "10px",
                },
                "@media (max-width: 400px)": {
                  maxWidth: "250px",
                },
              },
            }}
          >
            {title}
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 12,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          {title !== "Cancel Job" && <Divider />}
        </>
      )}
      {logo ? (
        <div className="flex md:gap-[32px] gap-2 flex-col justify-center items-center p-2">
          <img src={Logo} alt="logo" className="w-[170px] h-[144px]" />
          <p className="md:text-[24px] text-[20px] text-[#242424]  font-medium">
            {logoDetail}
          </p>
        </div>
      ) : logoDetail ? (
        <h1 className="md:text-[32px] text-[20px] text-[#242424] text-center font-medium md:py-[30px] py-[10px] ">
          {logoDetail}
        </h1>
      ) : null}
      {children}

      {footer && (
        <>
          {title !== "Cancel Job" && <Divider />}
          <DialogActions
            sx={{
              padding: "16px",
              "@media (max-width: 768px)": {
                padding: title === "Complete Job" ? "0px" : "10px",
              },
            }}
          >
            {footer}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default GenericModal;
